import cx from 'classnames';
import { useEffect, useState } from 'react';
import { ButtonV2 } from '../../ButtonV2/ButtonV2';
import InfoDialogUI from '../../InfoDialog/InfoDialogUI';
import styles from './ShareDialog.module.scss';
import { icons } from '../../../assets';
import { TabShareEmbed } from './TabShareEmbed';
import { TabShareExternal } from './TabShareExternal';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  configuratorActions,
  selectIsDataChanged,
} from '../../../redux/slicers/configurator/configurator.slicer';
import { closeInfoDialog } from '../../../redux/slicers/infoDialogSlicer';
import { openYesNoDialog } from '../../../hooks/useInfoDialogaActions';
import { getAllSceneToken } from '../../../api/configuratorApi';
import { Loader } from '../../../common';

const { CloseIcon2 } = icons;
// import { TabShareInternal } from './TabShareInternal'

export const ConfiguratorShareBody = ({ data, onClose }) => {
  const SHARE_TAB = {
    INTERNAL: 1,
    EXTERNAL: 2,
    EMBED_LINK: 3,
  };
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(SHARE_TAB.EXTERNAL);
  const [customLinks, setCustomLinks] = useState([]);
  const [allData, setAllData] = useState([]);
  const [scenes, setAllScenes] = useState([]);
  const v2 = Boolean(data?.version_type === 'V2');
  const SHARE_ACTION_LIST = [
    // {
    //   id: SHARE_TAB.INTERNAL,
    //   label: 'Internal',
    // },
    {
      id: SHARE_TAB.EXTERNAL,
      label: 'Share access',
      title: 'Share with anyone',
      description:
        'Choose the best preview for your public link to accurately represent the content and attract more user engagement',
    },
    {
      id: SHARE_TAB.EMBED_LINK,
      label: 'Custom links',
      title: `Custom links`,
      description: 'Create custom configurators link to share across your customers',
      updateLabel: true,
    },
  ];
  const activeTabConfig = SHARE_ACTION_LIST.find((i) => i.id === activeTab);
  const isDataChanged = useSelector(selectIsDataChanged);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    await getAllData();
    await getScenesData();
    await getCustomLinks();
    setLoading(false);
  };

  const getCustomLinks = async () => {
    const customLinks = await getAllSceneToken({ id: data?.id, sceneLinkType: 'COMBINATION', v2 });
    setCustomLinks(customLinks);
  };

  const getAllData = async () => {
    const allData = await getAllSceneToken({ id: data?.id, sceneLinkType: 'ALL', v2 });
    setAllData(allData?.[0]);
  };

  const getScenesData = async () => {
    const scenes = await getAllSceneToken({ id: data?.id, sceneLinkType: 'SCENE', v2 });
    setAllScenes(scenes);
  };

  const close = (callback) => {
    if (isDataChanged) {
      const cancel = () => {
        closeInfoDialog();
      };
      openYesNoDialog({
        title: 'Do you want to close current custom link editing?',
        description: 'All unsaved changes will be lost!',
        onClose: () => {
          cancel();
        },
        onCancelClick: () => {
          cancel();
        },
        onButtonClick: () => {
          cancel();
          !callback ? onClose && onClose() : callback && callback();
          dispatch(configuratorActions.setIsDataChanged(false));
        },
      });
      return;
    }
    !callback ? onClose && onClose() : callback && callback();
  };

  return (
    <div className={`${styles.container} ${!onClose ? 'rounded-0' : ''}`}>
      <div className={`${styles.tabs} d-flex justify-content-between align-items-center`}>
        <div className="h-100">
          {SHARE_ACTION_LIST.map((a) => (
            <ButtonV2
              key={a.id}
              color="dark"
              size="sm"
              onClick={() => {
                if (a.id === SHARE_TAB.EXTERNAL) {
                  close(() => {
                    setActiveTab(a.id);
                  });
                  return;
                }
                setActiveTab(a.id);
              }}
              className={cx(styles.tab, activeTab === a.id && styles.active, 'h-100')}>
              {a.label}
            </ButtonV2>
          ))}
        </div>
        {onClose && (
          <Button onClick={() => close()} className={styles.closeIcon}>
            <CloseIcon2 />
          </Button>
        )}
      </div>
      <div className={`w-100 position-relative ${styles.shareContainer}`}>
        {/* {activeTab === SHARE_TAB.INTERNAL && <TabShareInternal />} */}
        {!loading && activeTab === SHARE_TAB.EXTERNAL && (
          <TabShareExternal
            scenesData={scenes}
            allData={allData}
            data={data}
            title={activeTabConfig.title}
            description={activeTabConfig.description}
          />
        )}
        {!loading && activeTab === SHARE_TAB.EMBED_LINK && (
          <TabShareEmbed
            data={data}
            title={activeTabConfig.title}
            customData={customLinks}
            scenes={scenes}
            description={activeTabConfig.description}
            getCustomLinks={getCustomLinks}
          />
        )}
        <Loader loading={loading} backdrop thickness={3} position="absolute" />
      </div>
    </div>
  );
};

export const ShareDialog = ({ show, onClose }) => {
  return (
    <InfoDialogUI
      hideTitle
      dialogClassName={styles.dialog}
      bodyClassName={styles.modalBody}
      onClose={onClose}
      backdrop="static"
      show={show}
      centered={true}
      theme="v2">
      <ConfiguratorShareBody onClose={onClose} />
    </InfoDialogUI>
  );
};
